import { Component, OnInit, Input } from "@angular/core";
import * as moment from "moment";
declare var $: any;
import * as $ from "jquery";
import { NgForm } from '@angular/forms';

@Component({
  selector: "app-appliance-warranty",
  templateUrl: "./appliance-warranty.component.html",
  styleUrls: ["./appliance-warranty.component.scss"],
})
export class ApplianceWarrantyComponent implements OnInit {
  public mode: String = "EDIT";
  warrantyCoveredBy: any;
  purchaseDate: any;
  warrantyEndDate: any;
  today: any;
  f:NgForm;
  constructor() {}

  @Input() appliance: any;
  ngOnInit(): void {
    this.today = new Date().toISOString().split("T")[0];
    if (Boolean(this.appliance._id)) {
      this.mode = "EDIT";
      this.appliance.purchaseDate = moment(this.appliance.purchaseDate).format(
        "YYYY-MM-DD"
      );
      this.appliance.warrantyEndDate = moment(
        this.appliance.warrantyEndDate
      ).format("YYYY-MM-DD");
    }
    if (!Boolean(this.appliance._id)) {
      this.mode = "CREATE";
    }
  }

  show_details() {
    $(".show_details").toggle();
  }

  onSubmit(){
      this.appliance.warrantyFilled();
  }
}
